import React from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'
// import {ParallaxProvider, ParallaxBanner} from 'react-scroll-parallax'
import styled from 'styled-components'
import {
  FaPhone,
  FaEnvelope,
  // FaFacebook,
  // FaInstagram,
  // FaWhatsapp,
} from 'react-icons/fa'

// import Swiper core and required components
import SwiperCore, {Navigation, Pagination, Autoplay, A11y} from 'swiper'
import {Swiper, SwiperSlide} from 'swiper/react'

// Import Swiper styles
import 'swiper/swiper-bundle.min.css'

// install Swiper components
SwiperCore.use([Navigation, Autoplay, Pagination, A11y])

import Layout from '../components/layout'
import {Title} from '../components/Title'
import {Container} from '../components/Container'
import {Article} from '../components/Article'
import {Band} from '../components/Band'
import {spacingBig, spacingUnit} from '../cssConstants/spacing'
import {colorWhite, colorWine, colorGreen} from '../cssConstants/colors'
import {minWidthDesktop} from '../cssConstants/spacing'

// const Banner = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   color: colorWhite;

//   h2 {
//     font-weight: 300;
//     margin: 0;
//     line-height: 1;
//     font-size: 2rem;
//     text-align: center;
//   }
// `

// const Separator = styled.div`
//   height: 1rem;
//   ${'' /* margin-bottom: -2rem; */}
//   position: relative;
//   top: -0.5rem;
//   margin-bottom: -1rem;
//   background-image: url('${props => props.imgObj.url}');
//   background-repeat-x: repeat;
//   background-repeat-y: no-repeat;
// `

const BandSlideShow = styled(Band)`
  min-height: 90vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${props => props.position || 'flex-start'};

  ${Title} {
    ${'' /* margin-top: ${spacingBig * 2}rem; */}
    font-family: 'Belista';
    font-size: 5rem;
  }
`

const BandWhoWeAre = styled(Band)`
  min-height: 25rem;
  border-bottom: 1px solid #e9e6df;
  padding-bottom: 2rem;
  background-position-x: left;
  background-position-y: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const BandTeam = styled(Band)`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacingBig}rem;

  @media (min-width: ${minWidthDesktop}) {
    flex-direction: row;
    justify-content: space-between;
  }
`

const BandTeamItem = styled.div`
  &:not(:last-child) {
    margin-bottom: ${spacingUnit}rem;
  }
`
const BandTeamItemName = styled.div`
  color: ${colorWine};
  font-weight: bold;
`

const BandCucinaEbraica = styled(Band)`
  background: ${colorGreen};
  color: ${colorWhite};
  display: flex;
  flex-direction: column;

  ${Title} {
    color: ${colorWhite};
  }
`

const BandWhereWeAre = styled(Band)`
  min-height: 45rem;
  background: ${colorWhite};
  display: flex;
  flex-direction: column;
  align-content: center;

  a {
    color: inherit;
  }
`

const WhoWeAreIframe = styled.iframe.attrs({
  // Every <PasswordInput /> should be type="password"
  frameBorder: 0,
  allowFullScreen: true,
  'aria-hidden': false,
  tabIndex: 0,
  title: 'GoogleMaps',
})`
  width: 100%;
  height: 400px;
  border: 0;
`

export default function Home() {
  const data = useStaticQuery(graphql`
    query {
      logoDark: file(relativePath: {eq: "logo-lbt-dark.png"}) {
        childImageSharp {
          fixed(width: 350) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      cookingBackground: file(
        relativePath: {eq: "piatti-cucina-lebonton-rossi.jpg"}
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      bakeryBackground: file(relativePath: {eq: "bakery-background.png"}) {
        childImageSharp {
          fixed(width: 1920) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      slideShow01: file(relativePath: {eq: "01.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      slideShow02: file(relativePath: {eq: "02.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      slideShow03: file(relativePath: {eq: "03.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      slideShow04: file(relativePath: {eq: "04.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      slideShow05: file(relativePath: {eq: "05.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      slideShow06: file(relativePath: {eq: "06.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      slideShow07: file(relativePath: {eq: "07.jpg"}) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      giovanniTerracina: file(relativePath: {eq: "giovanni-terracina.png"}) {
        childImageSharp {
          fixed(width: 180) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      darioBascetta: file(relativePath: {eq: "dario-bascetta.png"}) {
        childImageSharp {
          fixed(width: 180) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      danieleTerracina: file(relativePath: {eq: "daniele-terracina.png"}) {
        childImageSharp {
          fixed(width: 180) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  const slides = [
    {
      title: 'Sobrietà ed Eleganza',
      color: colorWhite,
      img: data.slideShow02.childImageSharp.fluid.src,
    },
    {
      title: 'Fascino e Stile',
      color: colorWhite,
      img: data.slideShow04.childImageSharp.fluid.src,
    },
    {
      title: 'Amore ed Armonia',
      color: colorWhite,
      position: 'flex-end',
      img: data.slideShow05.childImageSharp.fluid.src,
    },
    {
      title: 'Gusto e Carattere',
      color: colorWine,
      img: data.slideShow06.childImageSharp.fluid.src,
    },
    {
      title: 'Sapore e Calore',
      color: colorWhite,
      img: data.slideShow07.childImageSharp.fluid.src,
    },
    {
      title: 'Profumo e Allegria',
      color: colorWine,
      img: data.slideShow01.childImageSharp.fluid.src,
    },
    {
      title: 'Fantasia e Creatività',
      color: colorWhite,
      img: data.slideShow03.childImageSharp.fluid.src,
    },
  ]

  const teams = [
    {
      name: 'Giovanni Terracina',
      role: 'Co-Founder & CEO',
      img: data.giovanniTerracina.childImageSharp.fixed,
    },
    {
      name: 'Dario Bascetta Greco',
      role: 'Co-Founder & Chef de cuisine',
      img: data.darioBascetta.childImageSharp.fixed,
    },
    {
      name: 'Daniele Terracina',
      role: 'Co-Founder & Sales Manager',
      img: data.danieleTerracina.childImageSharp.fixed,
    },
  ]

  return (
    // <ParallaxProvider>
    <Layout>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{clickable: true}}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        centeredSlides={true}
      >
        {slides.map(item => (
          <SwiperSlide key={item.img} style={{width: '100vw !important'}}>
            <BandSlideShow
              image={item.img}
              position={item.position || 'flex-start'}
            >
              <Title style={{color: item.color}}>{item.title}</Title>
            </BandSlideShow>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* <Separator imgObj={{url: data.separatorTop.childImageSharp.fixed.src}} /> */}

      <BandWhoWeAre image={data.bakeryBackground.childImageSharp.fixed.src}>
        <Container width="780px">
          <Title>Le Bon Ton Catering</Title>
        </Container>
        <Container width="780px">
          <Article>
            <p>
              Lebonton nasce nel 1992 da una storia di famiglia e di amicizia:
              Giovanni, Daniele e Dario, due fratelli e l&rsquo;amico di sempre
              della scuola alberghiera. Allora a Roma esisteva una sola
              macelleria kosher, non un solo ristorante e la cucina
              giudaico-romanesca autentica era quella che trovavi in tavola
              dalla nonne. Un catering interamente dedicato al kosher, capace di
              recuperare l&rsquo;enorme patrimonio culinario ebraico, coniugando
              tradizione e modernit&agrave;, sembrava un sogno visionario. Sono
              stati anni di grandi fatiche, qualche delusione ma soprattutto
              tante soddisfazioni, traguardi raggiunti e molte sfide che ancora
              ci aspettano.
            </p>
            <p>
              Abbiamo avuto l&rsquo;onore di accogliere capi di Stato e di
              Governo, Ambasciatori ed Eminenti personalit&agrave; del mondo
              ebraico e della societ&agrave; civile, organizzato e allestito
              banchetti nei luoghi pi&ugrave; belli d&rsquo;Italia: palazzi
              nobiliari, ville storiche, giardini monumentali.
            </p>
            <p>
              Ma il privilegio maggiore che ci viene concesso &egrave; di
              celebrare le occasioni speciali della vita: matrimoni, nascite,
              bar e bat mizva, nozze d&rsquo;argento, d&rsquo;oro, lauree,
              compleanni e quant&rsquo;altro. Momenti speciali, indimenticabili
              che cerchiamo di trasformare in sapori da consegnare alla memoria
              per sempre.
            </p>

            <BandTeam>
              {teams.map(item => (
                <BandTeamItem key={item.name}>
                  <Img fixed={item.img} fadeIn={false} />
                  <div>
                    <BandTeamItemName>{item.name}</BandTeamItemName>
                    {item.role}
                  </div>
                </BandTeamItem>
              ))}
            </BandTeam>
          </Article>
        </Container>
      </BandWhoWeAre>

      <BandCucinaEbraica>
        <Container width="780px">
          <Title>La cucina ebraica</Title>
        </Container>
        <Container width="780px">
          <Article>
            <p>
              La kasher&ugrave;t &egrave; l&rsquo;insieme delle regole
              alimentari ebraiche, una normativa complessa che proibisce il
              consumo di alcuni alimenti e, in alcuni casi, ne disciplina anche
              la preparazione. Esistono animali permessi ed animali proibiti,
              norme sulla macellazione degli animali permessi, regole sulla
              preparazione degli alimenti e indicazioni su alcuni cibi specifici
              come il vino e il pane. Kash&egrave;r (o k&ograve;sher, nella
              versione anglofona) significa adatto, ed identifica
              l&rsquo;idoneit&agrave; di un cibo ad essere consumato da un
              ebreo.
            </p>
            <p>
              Mangiare all&rsquo;ebraica vuol dire dunque e anzitutto mangiare
              kasher. Ma se la cucina ebraica &egrave; da un lato espressione di
              usanze antiche e sapori semplici che sanno di casa e di famiglia,
              dall&rsquo;altro rappresenta una delle tradizioni culinarie
              pi&ugrave; eclettiche sulla scena internazionale. La dispersione
              geografica e i continui movimenti migratori che hanno sempre
              caratterizzato la storia degli ebrei, hanno fatto s&igrave; che le
              abitudini alimentari tipiche del popolo ebraico &ndash; legate al
              rispetto della kasher&ugrave;t &ndash; si mischiassero con gli usi
              locali. Il risultato &egrave; quindi un&rsquo;arte culinaria
              antica di secoli che giunge fino ai giorni nostri arricchita e
              contaminata di tradizioni e culture diverse.
            </p>
            <p>
              Lebonton Catering propone una cucina ebraica autentica, fatta di
              materie prima di qualit&agrave;, controllate e certificate, di
              saperi antichi e di passione contemporanea.
            </p>
          </Article>
        </Container>
      </BandCucinaEbraica>

      <BandWhereWeAre>
        <Container width="780px">
          <Title>Dove Siamo</Title>
        </Container>
        <WhoWeAreIframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.4355202766515!2d12.513338416320744!3d41.883489879221614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61ed1fcee7fd%3A0xb6ecdd7f2f8adb40!2sVia%20Casoria%2C%2019%2C%2000182%20Roma%20RM!5e0!3m2!1sit!2sit!4v1605086823664!5m2!1sit!2sit" />
        <Container width="780px">
          <Article>
            <p>
              Le Bon Ton Catering si trova a Roma
              <br /> Via Casoria, 19 - 00182 Roma
            </p>
            <p>
              <FaPhone /> +39067026889
              <br />
              <FaEnvelope />{' '}
              <a href="mailto: info@lebonton.it">info@lebonton.it</a>
            </p>
          </Article>
        </Container>
      </BandWhereWeAre>
    </Layout>
    // </ParallaxProvider>
  )
}
